export class UpdateCustomMessageDistrictEntity {
  districtIds?: Array<number> | null;
}